'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@awesome.me/kit-94e593bf23/icons/sharp/light'
import { faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/regular'

import { useDropdown } from '@/app/_lib/hooks'

/**
 * SortSelect - Simple sort dropdown for category pages
 *
 * Displays as "Sort: [selection]" with inline label
 */
export default function SortSelect({ options, selectedKey, onSelect }) {
    const {
        isOpen,
        focusedIndex,
        containerRef,
        getTriggerProps,
        getListProps,
        getItemProps,
    } = useDropdown({
        items: options,
        onSelect,
        selectedValue: selectedKey,
        getItemValue: (item) => item.key,
        identifier: 'sort-select'
    })

    const selectedOption = options.find(opt => opt.key === selectedKey) || options[0]

    return (
        <div ref={containerRef} className="relative">
            <button
                type="button"
                className="flex items-center text-sm text-light hover:text-dark transition-colors"
                {...getTriggerProps()}
            >
                <span className="text-light mr-1">Sort:</span>
                <span className="text-dark">{selectedOption.label}</span>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`ml-2 text-xs text-light transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <ul
                    className="absolute top-full right-0 mt-1 min-w-[180px] bg-white shadow-lg border border-gray-10 z-50"
                    {...getListProps()}
                >
                    {options.map((option, index) => (
                        <li key={option.key} {...getItemProps(option, index)}>
                            <div className={`flex items-center justify-between w-full px-3 py-2 text-sm text-left hover:bg-gray-3 transition-colors cursor-pointer ${focusedIndex === index ? 'bg-gray-3' : ''}`}>
                                <span>{option.label}</span>
                                {selectedKey === option.key && (
                                    <FontAwesomeIcon icon={faCheck} className="text-xs text-lime-600 ml-3" />
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
